import { render } from "./MainHeaderComponent.vue?vue&type=template&id=0cf17cf7&scoped=true"
import script from "./MainHeaderComponent.vue?vue&type=script&lang=js"
export * from "./MainHeaderComponent.vue?vue&type=script&lang=js"

import "./MainHeaderComponent.vue?vue&type=style&index=0&id=0cf17cf7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0cf17cf7"

export default script